<template>
    <td-dialog
        :title="title"
        @cancel="dialogManageClose"
        :before-close="dialogManageClose"
        :visible.sync="dialogManageVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="430px"
        top="18vh"
    >
        <el-form :model="formDataManage" label-position="right" label-width="100px" ref="formDataManage" :rules="rules">
            <el-row style="padding-top:0px" v-for="(item, index) in dataList" :key="item.sColumnName">
                <el-col :span="12" v-if="item.sUiType === 'input'" style="width:100%;">
                    <el-form-item :label="item.sColumnNotes" :prop="item.sColumnName" class="autoCreateId">
                        <td-input v-model="item.inputValue" :type="item.param" :disabled="item.iPrimaryKey === 1 && item.iChecked === 0 ? true : false"></td-input>
                        <td-checkbox v-if="item.iPrimaryKey === 1" style="margin-left:10px;" :checked="true" :disabled="!isAddData" @change="autoCreateId(index)">{{
                            $t('pgCommon.AUTO_CREATE')
                        }}</td-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="item.sUiType === 'select'">
                    <el-form-item :label="item.sColumnNotes">
                        <td-select :options="item.param" keys="S_CODE" text="S_VALUE" v-model="item.inputValue" :placeholder="$t('pgCommon.PLEASE_SELECT')"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="item.sUiType === 'radio'">
                    <el-form-item :label="item.sColumnNotes" :prop="item.sColumnName">
                        <td-radio :options="item.param" keys="S_CODE" text="S_VALUE" v-model="item.inputValue"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="item.sUiType === 'checkbox'">
                    <el-form-item :label="item.sColumnNotes" :prop="item.sColumnName">
                        <el-checkbox v-model="item.inputValue" :label="item.param">{{ item.param }}</el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="item.sUiType === 'checkboxgroup'">
                    <el-form-item :label="item.sColumnNotes" :prop="item.sColumnName">
                        <el-radio-group v-model="item.inputValue">
                            <el-checkbox v-for="op in item.param" :key="op.S_CODE" :label="op.S_VALUE"></el-checkbox>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="item.sUiType === 'inputNumber'">
                    <el-form-item :label="item.sColumnNotes" :prop="item.sColumnName">
                        <td-inputNumber v-model="item.inputValue"></td-inputNumber>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="item.sUiType === 'time'">
                    <el-form-item :label="item.sColumnNotes" :prop="item.sColumnName">
                        <td-date-time type="time" :placeholder="$t('pgCommon.SELECT_DATE')" v-model="item.inputValue"></td-date-time>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="item.sUiType === 'date'">
                    <el-form-item :label="item.sColumnNotes" :prop="item.sColumnName">
                        <td-date-time type="date" :placeholder="$t('pgCommon.SELECT_DATE')" v-model="item.inputValue"></td-date-time>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="item.sUiType === 'datetime'">
                    <el-form-item :label="item.sColumnNotes" :prop="item.sColumnName">
                        <td-date-time type="datetime" :placeholder="$t('pgCommon.SELECT_DATE')" v-model="item.inputValue"></td-date-time>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="addLoading" @click="submitForm('formDataManage')">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import dataApi from './../assets/api.js';
export default {
    props: ['title', 'propertyList', 'dialogManageVisible', 'editItem', 'isAddData', 'nowTreeItem'],
    created() {
        this.editItemNew = this.editItem;
        this.dataList = window.vue.$util.clone(this.propertyList);
        // 初始化控件验证
        this.initValidation();
        this.initEditData();
    },
    // 定义变量
    data() {
        return {
            // 表单信息
            formDataManage: {},
            addLoading: false, // 按钮是否为加载状态
            editItemNew: {},
            dataList: [],
            // 对表单进行数据验证
            rules: {}
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initValidation() {
            for (let i = 0; i < this.dataList.length; i++) {
                const element = this.dataList[i];
                // 不能为空
                if (element.iCanEmpty === 0) {
                    this.rules[element.sColumnName] = [];
                    this.rules[element.sColumnName].push({
                        required: true,
                        validator: this.validateRes,
                        trigger: 'blur'
                    });
                }
            }
        },

        // 验证
        validateRes(rule, value, callback) {
            for (let j = 0; j < this.dataList.length; j++) {
                const element = this.dataList[j];
                if (element.sColumnName === rule.field) {
                    if (element.iPrimaryKey != 1 || (element.iPrimaryKey === 1 && element.iChecked === 1)) {
                        if (element.inputValue == null || element.inputValue === '' || element.inputValue === undefined) {
                            const message = this.$t('common.PLEASE_INPUT') + element.sColumnNotes;
                            callback(message);
                            return;
                        }
                        this.checkIllegal(element, callback);
                        if (element.isCanRepeat === 1) {
                            this.checkPropertyRepeat(element, callback);
                        }
                    }
                    callback();
                }
            }
        },

        // 动态控件非法正则验证
        checkIllegal(item, callback) {
            if (
                (item.sUiType === 'input' || item.sUiType === 'time' || item.sUiType === 'date' || item.sUiType === 'datetime' || item.sUiType === 'inputNumber') &&
                item.sValidityRegx != null &&
                item.sValidityRegx != '' &&
                item.sValidityRegx != undefined
            ) {
                let reg = new RegExp(item.sValidityRegx);
                if (!reg.test(item.inputValue)) {
                    callback(this.$t('pgError.ERROR_INPUT_ILLAGE'));
                    return;
                }
            }
        },

        // 验证是否重复 TODO
        checkPropertyRepeat(item, callback) {
            callback(item.propertyName + this.$t('common.REPEAT'));
            return;
        },

        // 初始化编辑数据
        initEditData() {
            for (let i = 0; i < this.dataList.length; i++) {
                const property = this.dataList[i];
                if (!this.isAddData) {
                    if (property.sUiType === 'inputNumber') {
                        property.inputValue = Number(this.editItemNew[property.sColumnName]);
                    } else {
                        if (this.editItemNew[property.sColumnName] != null && this.editItemNew[property.sColumnName] !== '' && this.editItemNew[property.sColumnName] != undefined) {
                            property.inputValue = this.editItemNew[property.sColumnName].toString();
                        } else {
                            property.inputValue = this.editItemNew[property.sColumnName];
                        }
                    }
                } else {
                    if (property.sDefaultValue === null || property.sDefaultValue === '' || property.sDefaultValue === undefined || property.sDefaultValue === 'NULL') {
                        property.inputValue = null;
                    } else {
                        if (property.sUiType === 'inputNumber') {
                            property.inputValue = Number(property.sDefaultValue);
                        } else {
                            property.inputValue = property.sDefaultValue.toString();
                        }
                    }
                }
            }
        },

        // 自动生成id
        autoCreateId(index) {
            if (this.dataList[index].iChecked === 0) {
                this.dataList[index].iChecked = 1;
            } else {
                this.dataList[index].iChecked = 0;
                this.dataList[index].inputValue = '';
            }
        },

        // 提交数据
        submitForm(formDataManage) {
            this.$refs[formDataManage].validate(valid => {
                if (valid) {
                    this.addLoading = true;
                    let extendInfos = [];
                    this.dataList.forEach(v => {
                        let propertyInfo = {};
                        propertyInfo.key = v.sColumnName;
                        if (v.sUiType === 'date') {
                            propertyInfo.value = v.inputValue + ',date';
                        } else if (v.sUiType === 'time') {
                            propertyInfo.value = v.inputValue + ',time';
                        } else if (v.sUiType === 'datetime') {
                            propertyInfo.value = v.inputValue + ',datetime';
                        } else {
                            propertyInfo.value = v.inputValue;
                        }
                        extendInfos.push(propertyInfo);
                    });
                    let content = {
                        trusteeshipId: this.nowTreeItem.sId,
                        data: extendInfos
                    };
                    if (this.isAddData) {
                        dataApi.insertData(JSON.stringify(content), response => {
                            this.addLoading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dataApi.insertData', response);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                            this.dialogManageClose();
                            this.$emit('queryDataList');
                        });
                    } else {
                        dataApi.updateData(JSON.stringify(content), response => {
                            this.addLoading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dataApi.updateData', response);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('pgCommon.MODIFY_SUCCESS'), type: 'success' });
                            this.dialogManageClose();
                            this.$emit('queryDataList');
                        });
                    }
                }
            });
        },

        // 取消
        cancel() {
            this.dialogManageClose();
        },

        // 关闭窗口之前需要调用的方法
        dialogManageClose() {
            this.$emit('dialogManageClose');
            this.editItemNew = null;
            this.dataList = [];
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.autoCreateId .el-form-item__content {
    margin-left: 30%;
    width: 100%;
}
</style>
